<template>
  <el-dialog
    :visible.sync="visible"
    title="图片上传"
    width="50%">
    <div class="upload-list">
      <ul class="clear-both">
        <li v-for="(file, index) in files"
            :key="index">
          <div class="upload-image"
               v-loading="file.loading">
            <img :src="file.src"
                 :alt="file.src">
            <div class="upload-image-status">
              <el-button v-show="file.status === 'success'"
                         class="el-icon-success"
                         type="success"
                         size="mini"> 上传成功
              </el-button>
              <el-button v-show="file.status === 'error'"
                         class="el-icon-error"
                         type="danger"
                         size="mini"
                         @click="onUploadFile(file)"> 重新上传
              </el-button>
            </div>
            <div class="upload-image-toolbar">
              <el-button-group v-if="isShow(index)">
                <el-button type="primary"
                           icon="el-icon-edit-outline"
                           size="mini"
                           @click="onEditImage(index)"></el-button>
                <el-button type="danger"
                           icon="el-icon-delete"
                           size="mini"
                           @click="onDelete(index)"></el-button>
              </el-button-group>
            </div>
          </div>
        </li>
        <li class="sj-icon-add-image">
          <input v-if="visible"
                 type="file"
                 accept="image/jpeg, image/png, image/gif"
                 multiple
                 @change="onSelectFile">
        </li>
      </ul>
      <span class="color-danger"
            style="font-size: 12px;line-height: 40px;">为避免前端闪退，请控制上传照片尺寸≤1000*1000，大小≤500KB。</span>
    </div>
    <span slot="footer">
      <el-button @click="visible = false">关 闭</el-button>
      <el-button type="primary"
                 :disabled="files.length === 0"
                 @click="onUploadFiles()">开始上传
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import cropperImage from '@/views/question-review/components/CropperImage/src/CropperImage.vue'

const URL = window.URL || window.webkitURL
export default {
  components: {},
  props: {},
  data () {
    return {
      visible: false,
      files: [
        // {
        //   src: '',
        //   datetime: '2016:03:14 15:22:33',
        //   loading: false,
        //   status: '' // success error
        // }
      ],
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    isShow (index) {
      let file = this.files[index]
      return !file.status && !file.loading
    },
    beforeAvatarUpload (file) {
      const maxSize = 5120
      const isMore = file.size / 1024 / maxSize > 1
      if (isMore) {
        this.$message.error(`上传文件大小不能超过 ${maxSize}KB!`)
      }
      return !isMore
    },
    onSelectFile (event) {
      let files = [...event.target.files]
      files.forEach(file => {
        if (this.beforeAvatarUpload(file)) {
          this.files.push({
            src: URL.createObjectURL(file),
            data: file,
            loading: false,
            status: '',
          })
        }
      })
    },
    onEditImage (index) {
      let file = this.files[index]
      cropperImage({
        url: file.src,
        callback (blob) {
          URL.revokeObjectURL(file.data)
          file.src = URL.createObjectURL(blob)
          file.data = blob
        },
      })
    },
    onDelete (index) {
      this.files.splice(index, 1)
    },
    onUploadFile (file) {
      file.loading = true
      this.callback(file.data, this).then((src) => {
        file.status = 'success'
      }, (error) => {
        file.status = 'error'
        throw Error(error)
      }).finally(() => {
        file.loading = false
      })
    },
    onUploadFiles () {
      this.files.forEach(file => {
        if (file.status !== 'success' && !file.loading) {
          this.onUploadFile(file)
        }
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
.upload-list {
  margin-bottom: -30px;

  ul {
    margin: 0px;
    padding: 0px;
    list-style-type: none;

    li {
      float: left;
      margin: 10px 10px 30px;
      border: 1px solid #c0c4cc;
      width: 130px;
      height: 130px;
      position: relative;
      /**
       * 上传图片按钮
       */
      &.sj-icon-add-image {
        color: #c0c4cc;
        border: 1px solid transparent;
        font-size: 130px;
        line-height: 130px;

        input {
          cursor: pointer;
          font-size: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          position: absolute;
          top: 0px;
          left: 0px;
        }
      }

      /**
       * 图片列表
       */
      .upload-image {
        position: relative;
        vertical-align: middle;
        text-align: center;
        height: 100%;
        width: 100%;

        &::before {
          content: "";
          display: inline-block;
          height: 100%;
          vertical-align: middle;
          width: 0;
        }

        img {
          max-width: 130px;
          max-height: 130px;
          vertical-align: middle;
        }

        /**
          * 图片状态
          */
        .upload-image-status {
          position: absolute;
          width: 130px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }

        /**
          * 图片操作
          */
        .upload-image-toolbar {
          display: none;
          position: absolute;
          bottom: 8px;
          left: 0px;
          width: 130px;
          padding-top: 5px;
        }

        &:hover .upload-image-toolbar {
          display: block;
        }
      }

      /**
       * 图片创建日期
       */
      .upload-image-date {
        position: absolute;
        bottom: -28px;
        left: 0px;
        width: 130px;
        font-size: 12px;
        color: #909399;
        cursor: pointer;
        text-align: center;

        &:hover {
          color: #409eff;
        }

        .modify-image-date {
          width: 190px;
          transform-origin: center bottom 0px;
          position: absolute;
          left: -25px;
          bottom: 0px;
          margin-bottom: 27px;

          .el-date-editor.el-input {
            width: 190px;
          }

          .el-input--suffix .el-input__inner {
            padding-right: 0px;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/components/question-image-upload-box/src/main.vue